import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useModal } from 'react-hooks-use-modal'
import ModalContent from '../../../components/modals/modal_content'
import { EnterpriseSummary } from '../../../clients/kyousou_api_client'
import rightArrowBlack from '../../../images/right_arrow_black.png'

// マッチング中の企業の型定義
type MatchingEnterprise = EnterpriseSummary & {
  matchingFrom: 'idea' | 'partner' | 'enterprise'
}

/**
 * 企業詳細モーダルを管理するカスタムフック
 */
export const useEnterpriseDetailModal = () => {
  const navigate = useNavigate()
  const [currentEnterprise, setCurrentEnterprise] =
    React.useState<MatchingEnterprise | null>(null)
  const [Modal, open, close] = useModal('root', {
    preventScroll: true,
    focusTrapOptions: {
      clickOutsideDeactivates: true,
    },
  })

  const showEnterpriseDetail = (enterprise: MatchingEnterprise) => {
    setCurrentEnterprise(enterprise)
    open()
  }

  const handleClose = () => {
    close()
    setCurrentEnterprise(null)
  }

  const handleDetailClick = () => {
    if (currentEnterprise) {
      navigate(`/enterprises/detail/${currentEnterprise.id}`)
      handleClose()
    }
  }

  const handleChatClick = () => {
    if (currentEnterprise) {
      navigate('/chat')
      handleClose()
    }
  }

  const EnterpriseDetailModal = () => (
    <Modal>
      {currentEnterprise && (
        <ModalContent
          title="マッチング企業詳細"
          onClose={handleClose}
          className="w-[700px]"
        >
          <div className="p-6">
            {/* 企業概要セクション */}
            <div className="mb-6">
              <h3 className="text-lg font-bold mb-3">企業概要</h3>
              <p className="text-sm leading-relaxed mb-4">
                {currentEnterprise.description || '企業概要はありません。'}
              </p>
              <div className="flex justify-end">
                <button
                  onClick={handleDetailClick}
                  className="text-sm hover:underline flex items-center gap-1"
                >
                  詳細はこちら
                  <img
                    src={rightArrowBlack}
                    alt="矢印"
                    className="w-4 h-4 object-contain"
                  />
                </button>
              </div>
            </div>

            {/* チャットへ移動ボタン */}
            <div className="mb-6">
              <button
                onClick={handleChatClick}
                className="w-full bg-main-green text-white py-3 px-4 rounded-lg font-bold hover:bg-main-lightgreen transition-colors"
              >
                チャットへ
              </button>
            </div>

            {/* マッチングタグ */}
            <div className="mb-4">
              <span className="inline-block px-3 py-1 rounded-full bg-main-lightblue text-main-blue text-sm font-medium">
                {currentEnterprise.matchingFrom === 'idea' &&
                  '事業アイディアでマッチング'}
                {currentEnterprise.matchingFrom === 'partner' &&
                  '共創パートナー募集でマッチング'}
                {currentEnterprise.matchingFrom === 'enterprise' &&
                  '企業ページでマッチング'}
              </span>
            </div>
          </div>
        </ModalContent>
      )}
    </Modal>
  )

  return {
    EnterpriseDetailModal,
    showEnterpriseDetail,
    closeEnterpriseDetail: handleClose,
  }
}
